import { withNoAuthentication } from '../../components/auth/withNoAuthentication';
import SigninPage from '../../v2/components/_signin/SigninPage';

export default withNoAuthentication({ replacePath: '/workspace#dashboard' })(SigninPage);
